<div class="h-[540px] overflow-y-auto" [ngSwitch]="step_()">
	<app-intro-auth-modal
		*ngSwitchCase="'intro'"
		(stepChange)="onStepChange($event)"
	></app-intro-auth-modal>
	<app-selection-auth-modal
		*ngSwitchCase="'selection'"
		(providerSelected)="onProviderSelected($event)"
	></app-selection-auth-modal>
	<app-final-auth-modal *ngSwitchCase="'final'"></app-final-auth-modal>
</div>
<ui-content-footer
	[primaryAction]="{
		text: step_() === 'selection' ? 'Connect' : 'Next',
		action: onNext,
		disabled: isNextDisabled,
	}"
	[secondaryAction]="
		step_() === 'intro' ? null : { text: 'Back', action: onBack }
	"
></ui-content-footer>
